import { useBrand } from '@contexts/index'
import { upperCaseFirst } from 'upper-case-first'

const getPrivacyLink = (brand: string) => {
  switch (brand) {
    case 'lexus':
      return 'https://www.lexus.co.uk/customer-data/privacy-policy'
    case 'kinto':
      return 'https://www.kinto-uk.com/privacy-notice/'
    case 'toyota':
    default:
      return 'https://www.toyota.co.uk/footer/privacy-policy'
  }
}
const MarketingTerms = () => {
  const brand = useBrand()

  const privacyLink = getPrivacyLink(brand)

  return (
    <div className="mt-8">
      <p>
        Be assured that {upperCaseFirst(brand)} will only share your personal
        information with companies that are an integral part of fulfilling the
        services we deliver. If you would like to find out more about how we
        process your data please visit our{' '}
        <a
          className="underline"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>{' '}
        for details.
      </p>
    </div>
  )
}

export default MarketingTerms
